module.exports = __webpack_public_path__ + "static/media/Clack,Derrick.46e813cf.png";